import React, { useEffect } from 'react';

import {
	AnalyticsEventActions,
	AnalyticsEventSource,
	ErrorCategory,
	GenericErrorPage,
	useAnalytics,
} from '@atlassian/ptc-common';

import { parseErrorObjectToErrorCategory } from '../../utils/error';
import { UserNotFound } from '../ProfileError';

import * as Styled from './ProfilePage.styled';
import { type ProfileQueryData } from './types';

export const ERROR_SCREENS = new Map([[ErrorCategory.NotFound, UserNotFound]]);

export const ErrorScreen = ({ error }: Pick<ProfileQueryData, 'error'>) => {
	const analytics = useAnalytics();

	// Failed analytics
	useEffect(() => {
		analytics.pushTrackEvent({
			action: AnalyticsEventActions.FAILED,
			actionSubject: `${AnalyticsEventSource.USER_PROFILE_SCREEN}Load`,
			source: AnalyticsEventSource.USER_PROFILE_SCREEN,
		});
	}, [analytics]);

	const errorCategory = parseErrorObjectToErrorCategory(error);
	const ErrorComponent =
		errorCategory !== '' && ERROR_SCREENS.has(errorCategory as any)
			? ERROR_SCREENS.get(errorCategory)!
			: GenericErrorPage;

	return (
		<Styled.LoadingWrapper>
			<ErrorComponent />
		</Styled.LoadingWrapper>
	);
};
